<footer
    class="footer pt-[100px] max-[1200px]:pt-[70px] bg-[#CCD3CA] text-[#fff] relative border-t-[1px] border-solid border-[#e9e9e9]">
    <div
        class="footer-container flex flex-wrap justify-between relative items-center mx-auto min-[1600px]:max-w-[1500px] min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
        <div class="flex flex-wrap w-full footer-top pb-[100px] max-[1200px]:pb-[70px]">
            <div
                class="min-[1200px]:w-[33.33%] min-[992px]:w-[50%] min-[576px]:w-full w-full px-[12px] cr-footer-border">
                <div class="cr-footer-logo max-w-[400px] mb-[15px] pb-[0] flex items-center gap-[15px]">
                    <div class="image flex justify-center items-center">
                        <img src="assets/img/logo/biowellness-logo-without-text.png" alt="logo"
                            class="logo w-[100px] rounded-full border-4 border-green-600 bg-white object-cover p-[5px]">
                    </div>
                    <p class="font-Poppins text-[14px] text-[#000] mb-[0] leading-[1.75]"> Transforming Science into Sustainable BioSolutions.</p>
                </div>
                <div class="cr-footer">
                    <h4
                        class="cr-sub-title cr-title-hidden relative hidden max-[992px]:block font-Manrope text-[18px] max-[992px]:text-[15px] font-bold leading-[1.3] text-[#000] mb-[15px] max-[992px]:py-[15px] max-[992px]:mb-[0] max-[992px]:border-b-[1px] max-[992px]:border-solid max-[992px]:border-[#e9e9e9]">
                        Contact us 
                        <span class="cr-heading-res hidden"></span>
                    </h4>
                    <ul
                        class="cr-footer-links max-[992px]:hidden cr-footer-dropdown max-[1200px]:max-w-[500px] max-[992px]:mt-[24px] text-white">
                        <li
                            class="location-icon font-Poppins mb-[12px] text-[14px] leading-[26px] text-[#000] relative mt-[24px] pl-[30px] max-[1400px]:mt-[20px] mt-[-5px] mb-[12px]">
                            T-17, Third Floor, Haware Centurion Complex,<br>Sector-19A, Opp. Seawoods Railway Station (E),<br>Nerul (E), Navi Mumbai – 400706
                        </li>
                        <li
                            class="mail-icon mb-[12px] font-Poppins text-[14px] leading-[26px] text-[#000] relative pl-[30px] max-[1400px]:mt-[20px] max-[992px]:mt-[15px]">
                            <a href="javascript:void(0)"
                                class="transition-all duration-[0.3s] ease-in-out relative font-Poppins text-[14px] leading-[26px] text-[#000] hover:text-[#64b496]">vaishali.bagul@thebiowellness.in</a>
                        </li>
                        <li
                            class="phone-icon font-Poppins text-[14px] leading-[26px] text-[#000] relative pl-[30px] mb-[0] max-[1400px]:mt-[20px] max-[992px]:mt-[15px]">
                            <a href="javascript:void(0)"
                                class="transition-all duration-[0.3s] ease-in-out relative font-Poppins text-[14px] leading-[26px] text-[#000] hover:text-[#64b496]">
                               +91 7977828078</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div
                class="min-[1200px]:w-[16.66%] min-[992px]:w-[25%] min-[576px]:w-full w-full px-[12px] cr-footer-border">
                <div class="cr-footer">
                    <h4
                        class="cr-sub-title font-Manrope relative text-[18px] font-bold leading-[1.3] text-[#000] mb-[15px] max-[992px]:py-[15px] max-[992px]:mb-[0] max-[992px]:text-[15px] max-[992px]:border-b-[1px] max-[992px]:border-solid max-[992px]:border-[#e9e9e9]">
                        Quick Links
                        <span class="cr-heading-res hidden"></span>
                    </h4>
                    <ul class="cr-footer-links max-[992px]:hidden cr-footer-dropdown max-[992px]:mt-[24px]">
                        @for (link of quickLinks;track link.route) {
                        <li
                            class="mb-[12px] font-Poppins text-[14px] leading-[26px] text-[#000] relative max-[992px]:my-[12px] max-[992px]:mt-[-5px]">
                            <a href="{{link.route}}"
                                class="transition-all duration-[0.3s] ease-in-out relative font-Poppins text-[14px] leading-[26px] text-[#000] hover:text-[#64b496]">{{link.title}}</a></li>
                        }
                        
                        
                       
                    </ul>
                </div>
            </div>
            <div
                class="min-[1200px]:w-[16.66%] min-[992px]:w-[25%] min-[576px]:w-full w-full px-[12px] cr-footer-border">
                <div class="cr-footer">
                    <h4
                        class="cr-sub-title font-Manrope relative text-[18px] font-bold leading-[1.3] text-[#000] mb-[15px] max-[992px]:py-[15px] max-[992px]:mb-[0] max-[992px]:text-[15px] max-[992px]:border-b-[1px] max-[992px]:border-solid max-[992px]:border-[#e9e9e9]">
                        Our Brands
                        <span class="cr-heading-res hidden"></span>
                    </h4>
                    <ul class="cr-footer-links max-[992px]:hidden cr-footer-dropdown max-[992px]:mt-[24px]">
                        @for(brand of ourBrands; track brand.route) {
                        <li
                            class="mb-[12px] font-Poppins text-[14px] leading-[26px] text-[#000] relative max-[992px]:my-[12px] max-[992px]:mt-[-5px]">
                            <a href="{{brand.route}}"
                                class="transition-all duration-[0.3s] ease-in-out relative font-Poppins text-[14px] leading-[26px] text-[#000] hover:text-[#64b496]">{{brand.title}}</a></li>
                        }
                        
                    </ul>
                </div>
            </div>
            <div class="min-[1200px]:w-[33.33%] min-[992px]:w-full w-full px-[12px] cr-footer-border">
                <div
                    class="cr-footer cr-newsletter max-[1200px]:mt-[50px] max-[1200px]:pt-[50px] max-[1200px]:border-t-[1px] max-[1200px]:border-solid max-[1200px]:border-[#e1dfdf] max-[992px]:mt-[0] max-[992px]:pt-[0] max-[992px]:border-[0]">
                    <h4
                        class="cr-sub-title font-Manrope relative text-[18px] font-bold leading-[1.3] text-[#000] mb-[15px] max-[992px]:py-[15px] max-[992px]:mb-[0] max-[992px]:text-[15px] max-[992px]:border-b-[1px] max-[992px]:border-solid max-[992px]:border-[#e9e9e9]">
                        Check Us Out On Social Media
                        <span class="cr-heading-res hidden"></span>
                    </h4>
                     <!-- <div
                        class="cr-footer-links max-[992px]:hidden cr-footer-dropdown max-[1200px]:max-w-[500px] max-[992px]:mt-[24px]">
                        <form class="cr-search-footer relative">
                            <input
                                class="search-input w-full h-[44px] py-[5px] px-[15px] border-[1px] border-solid border-[#e9e9e9] outline-[0] rounded-[5px]"
                                type="text" placeholder="Search here...">
                            <a href="javascript:void(0)"
                                class="search-btn w-[50px] absolute right-[0] top-[0] bottom-[0] flex items-center justify-center">
                                <i class="ri-send-plane-fill text-[21px] text-[#000]"></i>
                            </a>
                        </form>
                    </div>  -->
                    <div
    class="cr-social-media my-[22px] mx-[-2px] flex flex-row max-[992px]:mt-[40px] max-[992px]:mr-[0] max-[992px]:mb-[24px] max-[992px]:ml-[0] max-[992px]:flex-wrap">

    <!-- YouTube -->
    <span class="m-[2px] font-Poppins text-[50px] font-normal leading-[1.625] text-white">
        <a href="https://www.youtube.com/@BiowellnessBiosolutions" target="_blank" rel="noopener noreferrer"
            class="transition-all duration-[0.3s] ease-in-out w-[60px] h-[60px] flex items-center justify-center leading-[11px] bg-[#03492f] border-[3px] border-solid border-[#03492f] rounded-[5px] text-[#000] hover:text-[#64b496]">
            <i class="ri-youtube-line text-[#fff]"></i>
        </a>
    </span>

    <!-- Instagram -->
    <span class="m-[2px] font-Poppins text-[50px] font-normal leading-[1.625] text-white">
        <a href="https://www.instagram.com/biowellnessbiosolutions?igsh=MWd1ODJtY3B0ZHh4cg==" target="_blank" rel="noopener noreferrer"
            class="transition-all duration-[0.3s] ease-in-out w-[60px] h-[60px] flex items-center justify-center leading-[11px] bg-[#03492f] border-[3px] border-solid border-[#03492f] rounded-[5px] text-white hover:text-[#64b496]">
            <i class="ri-instagram-line text-[#fff]"></i>
        </a>
    </span>

    <!-- LinkedIn -->
    <span class="m-[2px] font-Poppins text-[50px] font-normal leading-[1.625] text-white">
        <a href="https://www.linkedin.com/in/biowellness-biosolutions-6377b539b/" target="_blank" rel="noopener noreferrer"
            class="transition-all duration-[0.3s] ease-in-out w-[60px] h-[60px] flex items-center justify-center leading-[11px] bg-[#03492f] border-[3px] border-solid border-[#03492f] rounded-[5px] text-white hover:text-[#64b496]">
            <i class="ri-linkedin-line text-[#fff]"></i>
        </a>
    </span>

</div>

                    <!-- <div class="cr-payment">
                        <swiper-container slides-per-view="1" space-between="16" pagination="true"
                            autoplay-delay="3000" loop="true" class="cr-insta-slider">
                            <swiper-slide>
                                <a href="#" class="cr-payment-image relative flex">
                                    <img src="assets/img/insta/1.jpg" alt="insta" class="w-full rounded-[5px]">
                                    <div
                                        class="payment-overlay transition-all duration-[0.3s] ease-in-out rounded-[5px] w-full h-full absolute top-[0] left-[0]">
                                    </div>
                                </a>
                            </swiper-slide>
                            <swiper-slide>
                                <a href="#" class="cr-payment-image relative flex">
                                    <img src="assets/img/insta/2.jpg" alt="insta" class="w-full rounded-[5px]">
                                    <div
                                        class="payment-overlay transition-all duration-[0.3s] ease-in-out rounded-[5px] w-full h-full absolute top-[0] left-[0]">
                                    </div>
                                </a>
                            </swiper-slide>
                            <swiper-slide>
                                <a href="#" class="cr-payment-image relative flex">
                                    <img src="assets/img/insta/3.jpg" alt="insta" class="w-full rounded-[5px]">
                                    <div
                                        class="payment-overlay transition-all duration-[0.3s] ease-in-out rounded-[5px] w-full h-full absolute top-[0] left-[0]">
                                    </div>
                                </a>
                            </swiper-slide>
                        </swiper-container>
                        <!-- <div class="cr-insta-slider swiper-container">
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide">
                                        <a href="#" class="cr-payment-image relative flex">
                                            <img src="assets/img/insta/1.jpg" alt="insta" class="w-full rounded-[5px]">
                                            <div class="payment-overlay transition-all duration-[0.3s] ease-in-out rounded-[5px] w-full h-full absolute top-[0] left-[0]"></div>
                                        </a>
                                    </div>
                                    <div class="swiper-slide">
                                        <a href="#" class="cr-payment-image relative flex">
                                            <img src="assets/img/insta/2.jpg" alt="insta" class="w-full rounded-[5px]">
                                            <div class="payment-overlay transition-all duration-[0.3s] ease-in-out rounded-[5px] w-full h-full absolute top-[0] left-[0]"></div>
                                        </a>
                                    </div>
                                    <div class="swiper-slide">
                                        <a href="#" class="cr-payment-image relative flex">
                                            <img src="assets/img/insta/3.jpg" alt="insta" class="w-full rounded-[5px]">
                                            <div class="payment-overlay transition-all duration-[0.3s] ease-in-out rounded-[5px] w-full h-full absolute top-[0] left-[0]"></div>
                                        </a>
                                    </div>
                                    <div class="swiper-slide">
                                        <a href="#" class="cr-payment-image relative flex">
                                            <img src="assets/img/insta/4.jpg" alt="insta" class="w-full rounded-[5px]">
                                            <div class="payment-overlay transition-all duration-[0.3s] ease-in-out rounded-[5px] w-full h-full absolute top-[0] left-[0]"></div>
                                        </a>
                                    </div>
                                    <div class="swiper-slide">
                                        <a href="#" class="cr-payment-image relative flex">
                                            <img src="assets/img/insta/5.jpg" alt="insta" class="w-full rounded-[5px]">
                                            <div class="payment-overlay transition-all duration-[0.3s] ease-in-out rounded-[5px] w-full h-full absolute top-[0] left-[0]"></div>
                                        </a>
                                    </div>
                                    <div class="swiper-slide">
                                        <a href="#" class="cr-payment-image relative flex">
                                            <img src="assets/img/insta/6.jpg" alt="insta" class="w-full rounded-[5px]">
                                            <div class="payment-overlay transition-all duration-[0.3s] ease-in-out rounded-[5px] w-full h-full absolute top-[0] left-[0]"></div>
                                        </a>
                                    </div>
                                    <div class="swiper-slide">
                                        <a href="#" class="cr-payment-image relative flex">
                                            <img src="assets/img/insta/7.jpg" alt="insta" class="w-full rounded-[5px]">
                                            <div class="payment-overlay transition-all duration-[0.3s] ease-in-out rounded-[5px] w-full h-full absolute top-[0] left-[0]"></div>
                                        </a>
                                    </div>
                                    <div class="swiper-slide">
                                        <a href="#" class="cr-payment-image relative flex">
                                            <img src="assets/img/insta/8.jpg" alt="insta" class="w-full rounded-[5px]">
                                            <div class="payment-overlay transition-all duration-[0.3s] ease-in-out rounded-[5px] w-full h-full absolute top-[0] left-[0]"></div>
                                        </a>
                                    </div>
                                </div>
                            </div> 
                    </div> -->
                </div>
            </div>
        </div>
        <div class="cr-last-footer w-full py-[20px] border-t-[1px] border-solid border-[#e9e9e9] text-center">
            <p class="font-Poppins text-[14px] text-[#000] leading-[1.2] ">&copy; <span id="copyright_year"></span> <a
                    href="index.html" class="text-[#000]">2026 Biowellness Biosolutions</a>, All rights reserved.</p>
        </div>
    </div>
</footer>